module.exports = __webpack_public_path__ + "static/media/0030_IMG_LE_SOL_MEGALITH_MEGABROWN.65120886.png";